var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-if-bot',[_c('a',{staticClass:"hdr__nv__lng",on:{"click":_vm.changeLocale}},[_c('span',{staticClass:"hdr__nv__lng__hdn"},[_c('span',{staticClass:"hdr__nv__lng__wrp",class:{ 'hdr__nv__lng__wrp--bg': _vm.$i18n.locale === 'de' }},[_c('span',[_vm._v("EN")]),_c('span',[_vm._v("DE")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }